
import { ICommonPensionInputs, SimplePensionFormOfPayment } from 'app/calcs/pensions/interfaces'
import * as moment from 'moment'

enum Local701FormOfPayment {
    lifeOnly = 150,
    fiftyPercentHusbandAndWife = 152,
    seventyFivePercentHusbandAndwife = 153
  }

interface ILocal701PensionInputs extends ICommonPensionInputs {
    beginPaymentsAge: moment.Duration
    formOfPayment: Local701FormOfPayment | SimplePensionFormOfPayment
    payRate: number
    futureService: moment.Duration
    monthlyBenefit: number
    monthlyBenefit20180531: number
    contributionRate: number
}

export {
    ILocal701PensionInputs,
    Local701FormOfPayment
}



// WEBPACK FOOTER //
// ./src/app/calcs/customers/local701/interfaces/index.ts